/**
 * The build version of the client THIS tab loaded - read at runtime from `window.ngClientVersion`,
 * which the .NET script-tag esi fragment (`_AngularJavaScriptEsi.cshtml`) stamps next to the
 * `<script>` tags from the same `clientVersion.txt` the cms api's ClientVersionInfo serves. The
 * fragment is what varnish refreshes on deploy, so even an old cached page pairs the version with
 * the main it names.
 *
 * It is deliberately NOT imported from `environments/version.ts` any more (Baruch 2026-10-22): a new
 * constant every build changed main's content, and because ~110 chunks import from main, every build
 * renamed essentially the whole dist and busted every visitor's cache - see
 * docs/agents/deployment.md "Chunk churn". Nothing under src/ may import version.ts.
 *
 * '' when absent (dev `ng serve` has no fragment; the ssr server has no window): the client-version
 * interceptor then sends no header (the server lets header-less clients through by design) and the
 * nihul's stale-tab watch never reloads (an unparsable own version grades as "not stale").
 */
declare global {
    interface Window {
        ngClientVersion?: unknown;
    }
}

export function clientVersion(): string {
    if (typeof window === 'undefined') {
        return '';
    }
    const value = window.ngClientVersion;
    return typeof value === 'string' ? value.trim() : '';
}
